module.exports = __webpack_public_path__ + "static/0008-08a842cb33146951d2b7763d031c48fc.png";